export default __webpack_public_path__ + "static/media/contactBgDec2.0b15162e.png";